import React from 'react';
import SteepItemCircleSingleVoyage
    from "@containers/singleVoyage/views/stepperLine/steepItem/SteepItemCircleSingleVoyage";
import Box from '@mui/material/Box';
import {sx} from './sx'
import EmptyLineSingleVoyage from "@containers/singleVoyage/views/stepperLine/line/EmptyLineSingleVoyage";

interface IProps {
    steps: {
        color?: string,
        backgroundColor?: string,
        onClick?:()=>void
    }[]
}

const EmptyStepperLineSingleVoyage = ({steps}: IProps) => {

    const list = steps?.map((steep, index) => {
        return (
            <SteepItemCircleSingleVoyage
                number={index + 1}
                color={steep?.color}
                backgroundColor={steep?.backgroundColor}
                sx={sx.item}
                sxInner={sx.inner}
                onClick={steep?.onClick}
                key={index}
            />
        )
    })
    return (
        <Box
            sx={sx.root}
        >
            {!steps?.length && <EmptyLineSingleVoyage sx={sx.line}/>}

            {list}
        </Box>
    );
};

export default EmptyStepperLineSingleVoyage;